<template>
  <div class="search" id="search">
    <section>
      <div class="inner">
        <div class="container">
          <div class="heading">Find your new home today</div>
          <div class="search-bar">
            <input
              class="location"
              type="text"
              placeholder="Location (e.g. 'Doncaster' or 'DN2 6HY')"
              v-model="query"
            />
            <button @click="search('buy')">For sale</button>
            <button @click="search('rent')">To rent</button>
            <span v-if="locationerror">{{ locationerror }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "@/services/api"

export default {
  data() {
    return {
      query: "",
      locationerror: ""
    }
  },
  methods: {
    search(type) {
      api
        .geocode(this.query)
        .then(() => {
          this.$router.push(type + "?q=" + this.query)
        })
        .catch(() => (this.locationerror = "There was a problem finding the location"))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search {
  position: relative;
  z-index: 5;
  padding: 5rem 0;
  background: #f7f7f7;
}

.heading {
  text-align: center;
  font-size: 3rem;
  padding-bottom: 2rem;
  font-weight: bold;
}

.search-bar {
  text-align: center;
}

.location {
  width: 40rem;
  padding: 0 1rem;
  height: 5rem;
  border: 2px solid #ccc;
}

button {
  color: black;
  padding: 1rem 2rem;
  height: 5rem;
  border: 0;
  font-size: 1.7rem;
  cursor: pointer;
  position: relative;
  background: #a5e643;
  transition: all 0.4s;
  margin-left: 0.5rem;
}

.action button:hover {
  background: rgb(178, 243, 79);
}

@media screen and (max-width: 650px) {
  .location {
    display: block;
    margin: auto;
    margin-bottom: 0.5rem;
  }
}
</style>
